import {downloadFile, downloadPdfFile} from "@/utils/filesUtil";
import moment from "moment";
import patientService from "@/services/patientService";
import metricsService from "@/services/metricsService";
import resultadosCuestionariosService from "@/services/resultadosCuestionariosService";
import store from "@/store";
import sweetalertUtil from "@/utils/sweetalertUtil";


const useDownloads = () => {

    // Para reportes con histórico: cada fecha es opcional y no hay límite de 3 meses.
    const validateOptionalReportDateRange = (params) => {
        const from = params?.from ? moment(params.from, 'YYYY/MM/DD') : null;
        const to = params?.to ? moment(params.to, 'YYYY/MM/DD') : null;
        if ((from && !from.isValid()) || (to && !to.isValid())) {
            sweetalertUtil.fire({
                icon: "danger",
                text: "El rango de fechas no es válido"
            });
            return false;
        }
        if (from && to && from.isAfter(to, 'day')) {
            sweetalertUtil.fire({
                icon: "danger",
                text: "La fecha inicio no puede ser posterior a la fecha fin"
            });
            return false;
        }
        return true;
    }

    const validateReportDateRange = (params) => {
        if (!params?.from || !params?.to) {
            sweetalertUtil.fire({
                icon: "danger",
                text: "Debes seleccionar fecha inicio y fecha fin"
            });
            return false;
        }

        const from = moment(params.from, 'YYYY/MM/DD');
        const to = moment(params.to, 'YYYY/MM/DD');
        if (!from.isValid() || !to.isValid()) {
            sweetalertUtil.fire({
                icon: "danger",
                text: "El rango de fechas no es válido"
            });
            return false;
        }
        if (from.isAfter(to, 'day')) {
            sweetalertUtil.fire({
                icon: "danger",
                text: "La fecha inicio no puede ser posterior a la fecha fin"
            });
            return false;
        }
        if (to.isAfter(from.clone().add(3, 'months'), 'day')) {
            sweetalertUtil.fire({
                icon: "danger",
                text: "El rango no puede ser mayor a 3 meses"
            });
            return false;
        }

        return true;
    }


    const downloadExcelReportPatientInformation = async (params = {}) => {

        store.commit('setGeneralIsLoading', true)
    
        const fileName = "informacion-usuarios-"
    
        const response = await patientService.getExcelUserInformation(params);
        downloadFile(response.data, `${fileName}${moment().format("DD_MM_YYYY")}`)
    
        store.commit('setGeneralIsLoading', false)
    
    }

    const downloadAllUsersDirectoryReport = async (params = {}) => {

        store.commit('setGeneralIsLoading', true)

        const fileName = "directorio-usuarios-"

        const response = await metricsService.downloadAllUsersReport(params);
        downloadFile(response.data, `${fileName}${moment().format("DD_MM_YYYY")}`)

        store.commit('setGeneralIsLoading', false)

    }

    const downloadExcelReportInitialAndSubsequentsEvaluations = async () => {

        store.commit('setGeneralIsLoading', true)
    
        const fileName = "evaluaciones-iniciales-subsecuentes-"
    
        const response = await metricsService.downloadInitialSubsequentEvaluationReport(null);
        downloadFile(response.data, `${fileName}${moment().format("DD_MM_YYYY")}`)
    
        store.commit('setGeneralIsLoading', false)
    
    }

    const downloadExcelReportWaitingList = async () => {

        console.log("composable");

        store.commit('setGeneralIsLoading', true)
    
        const fileName = "lista-de-espera-"
    
        const response = await metricsService.downloadWaitingListReport(null);
        downloadFile(response.data, `${fileName}${moment().format("DD_MM_YYYY")}`)
    
        store.commit('setGeneralIsLoading', false)
    
    }

    const openWeeklyClientsReportModal = () => {
        const downloadModal = document.querySelector('#weeklyReportDownload')
        const modal = bootstrap.Modal.getOrCreateInstance(downloadModal)
        modal.show()
    }

    const downloadReportClientsWeekly = async (params) => {        
        if (!params || params.tenant_id == null) {
            sweetalertUtil.fire({
                icon: "danger",
                text: "Debes seleccionar una empresa"
            });
            return;
        }
        store.commit('setGeneralIsLoading', true)
    
        const fileName = "weekly-report-"
    
        const response = await metricsService.downloadWeeklyUsersReport(params);
        downloadPdfFile(response.data, `${fileName}${moment().format("DD_MM_YYYY")}`)        
    
        store.commit('setGeneralIsLoading', false)
    }

    const downloadExcelRegisteredUsers = async (params) => {

        store.commit('setGeneralIsLoading', true)
    
        const fileName = "usuarios-registrados-"
    
        const response = await metricsService.downloadRegisteredUsersReport(params);
        downloadFile(response.data, `${fileName}${moment().format("DD_MM_YYYY")}`)
    
        store.commit('setGeneralIsLoading', false)
    
    }

    const downloadAllSessionsBySesionDateReport = async (params) => {

        store.commit('setGeneralIsLoading', true)
        const fileName = `Sesiones agendadas por fecha de sesion rango de fechas ${formatDate(params.from)} a ${formatDate(params.to)}`
    
        const response = await metricsService.downloadAllSessionsReport(params);
        downloadFile(response.data, `${fileName} fecha descarga ${moment().format("DD-MM-YYYY")}`)
    
        store.commit('setGeneralIsLoading', false)
    
    }

    const downloadAllSessionsByCreatedAtReport = async (params) => {

        store.commit('setGeneralIsLoading', true)
    
        const fileName = `Sesiones agendadas por fecha de creacion rango de fechas ${formatDate(params.from)}-${formatDate(params.to)}`
    
        const response = await metricsService.downloadAllSessionsReport({...params, filter_created: true});
        downloadFile(response.data, `${fileName} fecha descarga ${moment().format("DD-MM-YYYY")}`)
    
        store.commit('setGeneralIsLoading', false)
    
    }

    const downloadConsultationReasonsReport = async (params) => {

        store.commit('setGeneralIsLoading', true)
    
        const fileName = `Motivos de consulta rango de fechas ${formatDate(params.from)} a ${formatDate(params.to)}`
    
        const response = await metricsService.downloadConsultationReasonsReport(params);
        downloadFile(response.data, `${fileName} fecha descarga ${moment().format("DD-MM-YYYY")}`)
    
        store.commit('setGeneralIsLoading', false)
    
    }

    const downloadPatientsConsultationReasonsReport = async (params) => {
        if (!params || params.tenant_id == null || params.tenant_id === '') {
            sweetalertUtil.fire({
                icon: "danger",
                text: "Debes seleccionar una empresa"
            });
            return;
        }
        const from = moment(params.from, 'YYYY/MM/DD');
        const to = moment(params.to, 'YYYY/MM/DD');

        store.commit('setGeneralIsLoading', true)
        try {
            const payload = {
                tenant_id: params.tenant_id,
                from: from.format('YYYY-MM-DD'),
                to: to.format('YYYY-MM-DD')
            }
            const fileName = `Motivos de consulta Legacy Resiliencia ${payload.from} a ${payload.to}`
            const response = await metricsService.downloadPatientsConsultationReasonsReport(payload);
            downloadFile(response.data, `${fileName} fecha descarga ${moment().format("DD-MM-YYYY")}`)
        } finally {
            store.commit('setGeneralIsLoading', false)
        }
    }

    const downloadExitQuestions2Report = async (params) => {

        store.commit('setGeneralIsLoading', true)
    
        const fileName = `Preguntas de salida 2.0`
    
        const response = await metricsService.downloadExitQuestions2Report(params);
        downloadFile(response.data, `${fileName} fecha descarga ${moment().format("DD-MM-YYYY")}`)
    
        store.commit('setGeneralIsLoading', false)
    }

    const downloadEvaluationFormsResilienceReport = async (params) => {

        store.commit('setGeneralIsLoading', true)
    
        const fileName = `Preguntas de salida - Resiliencia`
    
        const response = await metricsService.downloadEvaluationFormsResilienceReport(params);
        downloadFile(response.data, `${fileName} fecha descarga ${moment().format("DD-MM-YYYY")}`)
    
        store.commit('setGeneralIsLoading', false)
    }

    const downloadOpenAnswersResilienceReport = async (params) => {
        store.commit('setGeneralIsLoading', true)
        try {
            const range = params.from && params.to ? `${formatDate(params.from)} a ${formatDate(params.to)}`
                : params.from ? `desde ${formatDate(params.from)}`
                : params.to ? `hasta ${formatDate(params.to)}`
                : 'historico'
            const fileName = `Preguntas de salida abiertas - Resiliencia ${range}`
            const response = await metricsService.downloadOpenAnswersResilienceReport(params);
            downloadFile(response.data, `${fileName} fecha descarga ${moment().format("DD-MM-YYYY")}`)
        } catch (error) {
            // El 401 ya lo avisa el interceptor de respuesta.
            if (error.response?.status !== 401) {
                sweetalertUtil.fire({
                    icon: "danger",
                    text: "No se pudo generar el reporte. Intenta de nuevo."
                });
            }
        } finally {
            store.commit('setGeneralIsLoading', false)
        }
    }

    const downloadTPTTSSReport = async (params) => {

        store.commit('setGeneralIsLoading', true)
    
        const fileName = `Preguntas de salida - TPT TSS`
    
        const response = await metricsService.downloadTPTTSSReport(params);
        downloadFile(response.data, `${fileName} fecha descarga ${moment().format("DD-MM-YYYY")}`)
    
        store.commit('setGeneralIsLoading', false)
    }

    const downloadTPTTCTReport = async (params) => {

        store.commit('setGeneralIsLoading', true)
    
        const fileName = `Preguntas de salida - TPT TCT`
    
        const response = await metricsService.downloadTPTTCTReport(params);
        downloadFile(response.data, `${fileName} fecha descarga ${moment().format("DD-MM-YYYY")}`)
    
        store.commit('setGeneralIsLoading', false)
    }

    const downloadTPTTGBReport = async (params) => {

        store.commit('setGeneralIsLoading', true)
    
        const fileName = `Preguntas de salida - TPT TGB`
    
        const response = await metricsService.downloadTPTTGBReport(params);
        downloadFile(response.data, `${fileName} fecha descarga ${moment().format("DD-MM-YYYY")}`)
    
        store.commit('setGeneralIsLoading', false)
    }

    const downloadTPTUserInformation = async (params) => {

        store.commit('setGeneralIsLoading', true)
    
        const fileName = `Informacion de usuarios TPT`
    
        const response = await metricsService.downloadTPTUserInformation(params);
        downloadFile(response.data, `${fileName} fecha descarga ${moment().format("DD-MM-YYYY")}`)
    
        store.commit('setGeneralIsLoading', false)
    }

    const downloadGrupoBalintReport = async (params) => {

        store.commit('setGeneralIsLoading', true)
    
        const fileName = `Asistencia grupos Balint`
    
        const response = await metricsService.downloadGrupoBalintReport(params);
        downloadFile(response.data, `${fileName} fecha descarga ${moment().format("DD-MM-YYYY")}`)
    
        store.commit('setGeneralIsLoading', false)
    }

    const downloadFechaRespuestaCuestionariosReport = async (params) => {

        store.commit('setGeneralIsLoading', true)
    
        const fileName = `Calendario de evaluaciones bimensuales TPT`
    
        const response = await metricsService.downloadFechaRespuestaCuestionariosReport(params);
        downloadFile(response.data, `${fileName} fecha descarga ${moment().format("DD-MM-YYYY")}`)
    
        store.commit('setGeneralIsLoading', false)
    }

    const downloadRespuestasEvaluacionesBimensualesReport = async (params) => {

        store.commit('setGeneralIsLoading', true)
    
        const fileName = `Respuesta de evaluaciones bimensuales TPT`
    
        const response = await resultadosCuestionariosService.downloadResultadosCuestionariosReport(params);
        downloadFile(response.data, `${fileName} fecha descarga ${moment().format("DD-MM-YYYY")}`)
    
        store.commit('setGeneralIsLoading', false)
    }

    const formatDate = (date) => {
        return moment(date, 'YYYY/MM/DD').format('YYYY-MM-DD')
    }

    return {
        downloadExcelReportPatientInformation,
        downloadAllUsersDirectoryReport,
        downloadExcelReportInitialAndSubsequentsEvaluations,
        downloadExcelReportWaitingList,
        openWeeklyClientsReportModal,
        downloadReportClientsWeekly,
        downloadExcelRegisteredUsers,
        downloadAllSessionsBySesionDateReport,
        downloadAllSessionsByCreatedAtReport,
        downloadConsultationReasonsReport,
        downloadPatientsConsultationReasonsReport,
        downloadExitQuestions2Report,
        downloadEvaluationFormsResilienceReport,
        downloadOpenAnswersResilienceReport,
        downloadTPTTSSReport,
        downloadTPTTCTReport,
        downloadTPTTGBReport,
        downloadTPTUserInformation,
        downloadGrupoBalintReport,
        downloadFechaRespuestaCuestionariosReport,
        downloadRespuestasEvaluacionesBimensualesReport,
        validateReportDateRange,
        validateOptionalReportDateRange
    }

}

export default useDownloads;
